import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HeaderComponent } from './components/header/header.component';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { NavComponent } from './components/nav/nav.component';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BooleanTranslatorPipe } from './pipes/boolean-translator.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MessageDialogComponent } from './components/message-dialog/message-dialog.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { CampaignCardComponent } from './components/campaign-card/campaign-card.component';
import { HomepageDialogComponent } from './components/homepage-dialog/homepage-dialog.component';
import { ProductFocusComponent } from './components/product-focus/product-focus.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgChartsModule } from 'ng2-charts';
import { FocoDialogComponent } from './components/foco-dialog/foco-dialog.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { FocoFilterModalComponent } from './components/foco-filter-modal/foco-filter-modal.component';
import { PdfViewerDialogComponent } from './components/pdf-viewer-dialog/pdf-viewer-dialog.component';
import { TableauDialogComponent } from './components/tableau-dialog/tableau-dialog.component';
import { TableauEmbeddedVizComponent } from './components/tableau-embedded-viz/tableau-embedded-viz.component';
import { SplitOrderDialogComponent } from './components/split-order-dialog/split-order-dialog.component';
import { ConfirmReceptionDialogComponent } from './components/confirm-reception-dialog/confirm-reception-dialog.component';
import { DateSelectionDialogComponent } from './components/date-selection-dialog/date-selection-dialog.component';
import { ChildCsvDialogComponent } from './components/child-csv-dialog/child-csv-dialog.component';
import { DataTableComponent } from './components/data-table/data-table.component';
import { MustBeZeroOrMoreDirective } from './directives/must-be-zero-or-more.directive';

const ANGULAR_MATERIAL_MODULES = [
  MatDialogModule,
  MatTableModule,
  MatTabsModule,
  MatFormFieldModule,
  MatInputModule,
  MatDatepickerModule,
  MatButtonModule,
  MatListModule,
  LayoutModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatToolbarModule,
  MatSidenavModule,
  MatIconModule,
  MatCardModule,
  MatCheckboxModule,
  MatTooltipModule,
  MatSortModule,
  MatPaginatorModule,
  MatSnackBarModule,
  MatRadioModule,
  MatExpansionModule,
  MatGridListModule,
  MatSelectModule,
  MatSlideToggleModule,
  MatButtonToggleModule,
  NgChartsModule,
  MatAutocompleteModule,
];

@NgModule({
  declarations: [
    HeaderComponent,
    SpinnerComponent,
    ConfirmDialogComponent,
    MessageDialogComponent,
    HomepageDialogComponent,
    NavComponent,
    BooleanTranslatorPipe,
    CampaignCardComponent,
    ProductFocusComponent,
    FocoDialogComponent,
    SafeUrlPipe,
    FocoFilterModalComponent,
    PdfViewerDialogComponent,
    TableauDialogComponent,
    TableauEmbeddedVizComponent,
    SplitOrderDialogComponent,
    ConfirmReceptionDialogComponent,
    DateSelectionDialogComponent,
    ChildCsvDialogComponent,
    DataTableComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    DragDropModule,
    MustBeZeroOrMoreDirective,
    
    ...ANGULAR_MATERIAL_MODULES,
  ],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    HeaderComponent,
    SpinnerComponent,
    NavComponent,
    NgbModule,
    ...ANGULAR_MATERIAL_MODULES,
    BooleanTranslatorPipe,
    CampaignCardComponent,
    ProductFocusComponent,
    SafeUrlPipe,
    TableauEmbeddedVizComponent,
    DataTableComponent,
    MustBeZeroOrMoreDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
